// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout__layout___scc9v {
    display: grid;
    width: 100%;
    height: 100vh;
}

.Layout__showModeFull___aT4OJ {
    grid-template-rows: min-content 0 1fr;
}

.Layout__showModeHalf___v4ApT {
    grid-template-rows: min-content 1fr max-content;
}

.Layout__showModeNone___kL16x {
    grid-template-rows: min-content 1fr min-content;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Template/Layout/Layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD","sourcesContent":[".layout {\n    display: grid;\n    width: 100%;\n    height: 100vh;\n}\n\n.showModeFull {\n    grid-template-rows: min-content 0 1fr;\n}\n\n.showModeHalf {\n    grid-template-rows: min-content 1fr max-content;\n}\n\n.showModeNone {\n    grid-template-rows: min-content 1fr min-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `Layout__layout___scc9v`,
	"showModeFull": `Layout__showModeFull___aT4OJ`,
	"showModeHalf": `Layout__showModeHalf___v4ApT`,
	"showModeNone": `Layout__showModeNone___kL16x`
};
export default ___CSS_LOADER_EXPORT___;
